<template>
  <div>
    <!-- Active Bundle -->
    <b-card title="Active Bundle List" class="mb-2">
      <b-table
        responsive
        :items="activeBundles"
        :fields="fields"
        show-empty
        empty-text="No active bundle found"
      >
        <template #cell(sl)="data">
          {{ data.index + 1 }}
        </template>

        <template #cell(label)="data">
          {{ data.item.label }}
        </template>

        <template #cell(bundle_price)="data">
          {{ data.item.bundle_price }}
        </template>

        <template #cell(valid_from)="data">
          {{ data.item.valid_from | formatLocalDateTime }}
        </template>

        <template #cell(valid_to)="data">
          {{ data.item.valid_to | formatLocalDateTime }}
        </template>

        <template #cell(status)="data">
          <b-badge variant="success">
            {{ data.item.status }}
          </b-badge>
        </template>

        <template #cell(info)="data">
          <b-button size="sm" :style="{ width: '100px', marginBottom: '5px' }" variant="primary" @click="showModal(data.item)">
            Info
          </b-button>
        </template>
      </b-table>
    </b-card>

    <!-- Upcoming Bundle -->
    <b-card title="Upcoming Bundle List" class="mb-2">
      <b-table
        responsive
        :items="upcomingBundles"
        :fields="fields"
        show-empty
        empty-text="No upcoming bundle found"
      >
        <template #cell(sl)="data">
          {{ data.index + 1 }}
        </template>
      </b-table>
    </b-card>

    <!-- Previous Bundle -->
    <b-card title="Previous Bundle List">
      <b-table
        responsive
        :items="previousBundles"
        :fields="fields"
        show-empty
        empty-text="No previous bundle found"
      >
        <template #cell(sl)="data">
          {{ data.index + 1 }}
        </template>
      </b-table>
    </b-card>

    <div class="row">
      <div class="col-12 col-lg-6">
        <b-card>
          <div class="md">
            <h3 class="mt-10">How to Pay for MiME Internet from Selfcare</h3>
            <video class="responsive-video" width="100%" controls>
              <source :src="videoUrl" type="video/mp4" />
            </video>
          </div>
        </b-card>
      </div>
    </div>

    <b-modal
      v-model="modalVisible"
      title="Bundle Details"
      size="lg"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Service Name</th>
            <th>Package Name</th>
            <th>Price</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(line, index) in modalData.bundle_purchase_lines"
            :key="index"
          >
            <td>{{ line.bundle_line.service_name }}</td>
            <td>{{ line.bundle_line.package_name }}</td>
            <td>{{ line.bundle_line.proposed_price }}</td>
            <td>
              <b-badge
                :variant="line.services_activated_status === 'merged' ? 'success' : 'warning'"
              >
                {{ line.services_activated_status }}
              </b-badge>
            </td>
          </tr>

          <!-- Empty fallback -->
          <tr v-if="!modalData.bundle_purchase_lines || modalData.bundle_purchase_lines.length === 0">
            <td colspan="4" class="text-center">No data found</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BTable, BBadge, BButton, BModal } from "bootstrap-vue";
import api from "@/services/api";
import { formatDate } from "@/utils/dateUtils";
import { decrypt } from "@/utils/crypto";

export default {
  components: {
    BCard,
    BTable,
    BBadge,
    BButton, 
    BModal
  },

  data() {
    return {
      activeBundles: [],
      upcomingBundles: [],
      previousBundles: [],
      videoUrl: "/documents/How_to_Pay_for_MiME_Internet_from_Selfcare.mp4",
      modalVisible: false,
      modalData: {},

      fields: [
        { key: "sl", label: "#" },
        { key: "label", label: "Bundle Name" },
        { key: "purchase_mode", label: "Purchase Mode" },
        { key: "change_type", label: "Purchase Type" },
        { key: "valid_from", label: "Valid From" },
        { key: "valid_to", label: "Valid To" },
        { key: "bundle_price", label: "Total Price" },
        { key: "billed_price", label: "Billed Price" },
        { key: "status", label: "Status" },
        { key: "billable", label: "Billable" },
        { key: "info", label: "Info" },
      ],
    };
  },

  methods: {
    async fetchBundles() {
      const userData = decrypt(localStorage.getItem("userData"));
      const username = userData?.username;
      const loader = this.$showCustomLoader();
      try {
        const res = await api.get(
          `/package-bundle/bundle_latest_version/purchase_bundle/${username}/`
        );
        loader?.hide();

        this.activeBundles = res.data.current_bundle_list || [];
        this.upcomingBundles = res.data.upcoming_bundle || [];
        this.previousBundles = res.data.previous_bundle_list || [];
      } catch (error) {
        loader?.hide();
        console.error("Bundle fetch failed:", error);
      }
    },

    showModal(item) {
      this.modalData = item;
      this.modalVisible = true;
    }

  },

  mounted() {
    this.fetchBundles();
  },
};
</script>
<style scoped>
  .responsive-video {
    width: 100%;
    height: auto;
    max-width: 100%;
  }
</style>
